import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { ForumMockService } from '../forum-mock.service';
import { ForumCommunity, ForumPost, ForumSort } from '../forum.types';

@Component({
  selector: 'app-forum-community',
  templateUrl: './forum-community.component.html',
  styleUrls: ['./forum-community.component.css'],
})
export class ForumCommunityComponent implements OnInit {
  community?: ForumCommunity;
  posts: ForumPost[] = [];
  sort: ForumSort = 'hot';
  joined = false;

  constructor(
    private route: ActivatedRoute,
    private router: Router,
    private forum: ForumMockService
  ) {}

  ngOnInit(): void {
    this.route.paramMap.subscribe((pm) => {
      const slug = pm.get('slug') ?? '';
      this.community = this.forum.getCommunityBySlug(slug);
      this.joined = false;
      this.refresh();
      window.scrollTo({ top: 0, behavior: 'auto' });
    });
  }

  refresh(): void {
    if (this.community) {
      this.posts = this.forum.getPosts(this.sort, this.community.id);
    }
  }

  setSort(s: ForumSort): void {
    this.sort = s;
    this.refresh();
  }

  back(): void {
    this.router.navigate(['/forum']);
  }

  short(n: number): string {
    if (n >= 1000) return (n / 1000).toFixed(1).replace('.0', '') + 'k';
    return `${n}`;
  }
}
